import axios from 'axios';

const capi = axios.create({
	baseURL: '/_capi/'
});

capi.interceptors.response.use(
	function(response) {
		// Do something with response data
		return response;
	},
	function(error) {
		// Do something with response error
		return Promise.reject(error);
	}
);

export default capi;



// WEBPACK FOOTER //
// ./app/services/capi.js